import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LaptopWindowsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"laptop_windows"}/>
}
